export type TileState = 'correct' | 'present' | 'absent';
export type KeyState = TileState | 'unused';
/**
 * Which game produced a state. `'journey'` never touches the streak and
 * pays half rate (spec §10.3); `'challenge'` never touches the streak
 * either; only `'daily'` does.
 */
export type GameMode = 'daily' | 'challenge' | 'journey';
export type GameStatus = 'playing' | 'won' | 'lost';

export interface EvaluatedGuess {
  word: string;
  tiles: TileState[];
}

/**
 * The 5-letter game's length. **Legacy constant** (spec §10.1): it is the
 * default length for XP, the shape of the bundled 5-letter word lists, and
 * nothing else. Anything that has to work for a 4/6/7-letter game reads
 * `answer.length` and imports `SUPPORTED_LENGTHS` from ./lengths.
 */
export const WORD_LENGTH = 5;

/**
 * The 5-letter game's row count. **Legacy constant** (spec §10.1): kept as
 * the stats display floor. Use `maxGuessesFor(answer)` from ./lengths for
 * anything that depends on an actual game's board.
 */
export const MAX_GUESSES = 6;
